import { PageId } from 'constants/pages'

export const enum PageIdWoofzRt {
  SEX_RT_2_RTV2 = PageId.SEX_RT_2_RTV2,
  DOG_AGE_RT_RTV2 = PageId.DOG_AGE_RT_RTV2,
  URGE_RT_V1_RTV2 = PageId.URGE_RT_V1_RTV2,
  CHALLENGES_RT_RTV2 = PageId.CHALLENGES_RT_RTV2,
  WALKS_FEEL_RTV2 = PageId.WALKS_FEEL_RTV2,
  DOG_EXCITEMENTS_TRIGGERS_RTV2 = PageId.DOG_EXCITEMENTS_TRIGGERS_RTV2,
  URGE_RT_5_RTV2 = PageId.URGE_RT_5_RTV2,
  DOG_MISBEHAVES_RTV2 = PageId.DOG_MISBEHAVES_RTV2,
  DOG_ACT_RT_RTV2 = PageId.DOG_ACT_RT_RTV2,
  DOG_OFF_AT_HOME_RTV2 = PageId.DOG_OFF_AT_HOME_RTV2,
  URGE_RT_6_RTV2 = PageId.URGE_RT_6_RTV2,
  ACCESS_TO_FOOD_RTV2 = PageId.ACCESS_TO_FOOD_RTV2,
  URGE_RT_7_RTV2 = PageId.URGE_RT_7_RTV2,
  DOG_AGGRESSIVE_RT_RTV2 = PageId.DOG_AGGRESSIVE_RT_RTV2,
  DOG_CALM_DOWN_RT_RTV2 = PageId.DOG_CALM_DOWN_RT_RTV2,
  URGE_RT_8_RTV2 = PageId.URGE_RT_8_RTV2,
  DOG_BREED_RT_RTV2 = PageId.DOG_BREED_RT_RTV2,
  URGE_RT_9_RTV2 = PageId.URGE_RT_9_RTV2,
  COMMANDS_61_RT_RTV2 = PageId.COMMANDS_61_RT_RTV2,
  COMMANDS_62_RT_RTV2 = PageId.COMMANDS_62_RT_RTV2,
  COMMANDS_63_RT_RTV2 = PageId.COMMANDS_63_RT_RTV2,
  URGE_RT_10_RTV2 = PageId.URGE_RT_10_RTV2,
  URGE_LOADER_RT_RTV2 = PageId.URGE_LOADER_RT_RTV2,
  DOG_STATISTICS_RT_RTV2 = PageId.DOG_STATISTICS_RT_RTV2,
  TRAINING_RT_RTV2 = PageId.TRAINING_RT_RTV2,
  PREPARE_FLOW_RT_RTV2 = PageId.PREPARE_FLOW_RT_RTV2,
  EMAIL_RT_RTV2 = PageId.EMAIL_RT_RTV2,
  NEWSLETTER_URGE_RTV2 = PageId.NEWSLETTER_URGE_RTV2,
  URGE_RT_4_RTV2 = PageId.URGE_RT_4_RTV2,
  LAST_CHANCE_OFFER_RT_V2_RTV2 = PageId.LAST_CHANCE_OFFER_RT_V2_RTV2,
  SUBSCRIPTIONS_RT_RTV2 = PageId.SUBSCRIPTIONS_RT_RTV2,
  CHAT_UPSELL_RTV2 = PageId.CHAT_UPSELL_RTV2,
  UPSELL_1_RTV2 = PageId.UPSELL_1_RTV2,
  UPSELL_PITPAT_RTV2 = PageId.UPSELL_PITPAT_RTV2,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_RTV2 = PageId.DOWNLOAD_RTV2,
}
